import React from "react";
import styles from "./index.module.scss";
import MapPinIcon from "../../../icons/map-pin.icon";
import User2Icon from "../../../icons/subscription-status/user-2.icon";
import User3Icon from "../../../icons/subscription-status/user-3.icon";
import cn from "../../../../Utils/class-names.utils";
import ClockIcon from "../../../icons/subscription-status/clock.icon";
import NotesIcon from "../../../icons/subscription-status/notes.icon";

interface Badge {
  label: string;
  variant: "warning" | "referral";
}

interface InfoRow {
  icon?: React.ComponentType<{ className?: string }>;
  label: string;
  value: string;
}

const MspDetailsTooltip = () => {
  const companyData = {
    name: "M3 Networks",
    avatar: "/avatar.png",
  };

  const badges: Badge[] = [
    {
      label: "Medium Priority",
      variant: "warning",
    },
    {
      label: "Referral",
      variant: "referral",
    },
  ];

  const infoRows: InfoRow[] = [
    {
      icon: MapPinIcon,
      label: "Location:",
      value: "Scotland, United Kingdom",
    },
    {
      icon: User2Icon,
      label: "Contact:",
      value: "Mark Lamb",
    },
    {
      icon: User3Icon,
      label: "Sales Rep:",
      value: "Robin Smit",
    },
  ];

  const planData = {
    label: "Plan:",
    value: "Max. trial period expired",
  };

  const footerData = {
    notesCount: 3,
    userAvatar: "/image.png",
  };

  return (
    <article className={styles.tooltip}>
      <header className={styles.header}>
        <img
          src={companyData.avatar}
          alt={`${companyData.name} avatar`}
          className={styles.avatar}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = "/images/user-logo.svg";
          }}
        />
        <h2 className={styles.companyName}>
          {companyData.name}
        </h2>
      </header>

      <div
        className={styles.badgesContainer}
        role="group"
        aria-label="Status badges"
      >
        {badges.map((badge, index) => {
          const badgeClass = badge.variant === "warning" ? styles.badgeWarning : styles.badgeReferral;
          const badgeTextClass = badge.variant === "warning" ? styles.badgeTextWarning : styles.badgeTextReferral;
          
          return (
            <div
              key={index}
              className={styles.badgeWrapper}
            >
              <div className={styles.badgeInner}>
                <span
                  className={`${styles.badge} ${badgeClass}`}
                >
                  <span className={styles.badgeContent}>
                    <span className={`${styles.badgeText} ${badgeTextClass}`}>
                      {badge.label}
                    </span>
                  </span>
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <dl className={styles.infoList}>
        {infoRows.map((row, index) => {
          const IconComponent = row.icon;
          return (
            <div
              key={index}
              className={styles.infoRow}
            >
              {IconComponent && (
                <IconComponent
                  aria-hidden="true"
                />
              )}
              <span className={styles.infoText}>
                <span className={cn(styles.infoText, styles.infoTextBold)}>
                  {row.label}{" "}
                </span>
                <span className={styles.infoText}>
                  {row.value}
                </span>
              </span>
            </div>
          );
        })}
      </dl>

      <hr
        className={styles.divider}
        aria-hidden="true"
      />

      <div className={styles.planRow}>
        <ClockIcon />
        <p className={styles.planText}>
          <span className={cn(styles.planText, styles.planTextBold)}>
            {planData.label}
          </span>
          <span className={styles.planText}>
            {" "}
            {planData.value}
          </span>
        </p>
      </div>

      <footer className={styles.footer}>
        <div className={styles.footerLeft}>
          <NotesIcon />
          <span className={styles.notesCount}>
            {footerData.notesCount} notes
          </span>
        </div>
        <img
          src={footerData.userAvatar}
          alt="User avatar"
          className={styles.userAvatar}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = "/images/user-logo.svg";
          }}
        />
      </footer>
    </article>
  );
};

export default MspDetailsTooltip;
